import React from "react"

import Box, { BoxProps } from "./box"

export default function Row(props: Omit<BoxProps, "flexDirection">) {
  return (
    <Box
      {...props}
      alignItems={props.alignItems || "center"}
      justifyContent={props.justifyContent || "flex-start"}
      flexDirection="row"
    />
  )
}
